module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-theme-ui/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/@bottlebooks/gatsby-theme-event/gatsby-browser.js'),
      options: {"plugins":[],"rootPath":"/","homePath":"/producers","exhibitorBase":"partners","producerBase":"producers","productBase":"products","locale":"en","eventId":"5f6b2d57e64ef96d599a5ef5","withOverlay":false,"showCountryFilter":true},
    }]
